(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gsf-infinite-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gsf-infinite-scroll')) {
  customElements.define('gsf-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this.grid = this.closest('#ProductGridContainer')?.querySelector('ul#product-grid, #product-grid ul.product-grid');
      if (!this.grid || !this.dataset.next) return;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.load();
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    async load() {
      if (this.loading || !this.dataset.next || !this.isConnected) return;
      const container = this.closest('#ProductGridContainer');
      if (container.querySelector('.collection.loading')) return;
      const context = location.pathname + location.search;
      const url = new URL(this.dataset.next, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      url.searchParams.set('section_id', container.querySelector('#product-grid').dataset.id);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.controller = new AbortController();
      const timer = setTimeout(() => this.controller.abort(), 15000);
      try {
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Page unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || context !== location.pathname + location.search ||
            container.querySelector('.collection.loading')) return;
        const nextGrid = html.querySelector('ul#product-grid, #product-grid ul.product-grid');
        const nextPager = html.querySelector('gsf-infinite-scroll');
        if (!nextGrid || !nextPager || !nextGrid.children.length) throw new Error('Page unavailable');
        const known = new Set(Array.from(this.grid.querySelectorAll('h3[id]'), el => el.id));
        const items = Array.from(nextGrid.children).filter(el => {
          const id = el.querySelector('h3[id]')?.id;
          return !id || !known.has(id);
        });
        if (!items.length) throw new Error('Repeated page');
        items.forEach(el => {
          el.classList.add('scroll-trigger--cancel');
          el.querySelectorAll('.scroll-trigger').forEach(child => child.classList.add('scroll-trigger--cancel'));
          el.querySelectorAll('script').forEach(script => script.remove());
        });
        this.grid.append(...items);
        this.innerHTML = nextPager.innerHTML;
        this.dataset.next = nextPager.dataset.next || '';
        this.observer.disconnect();
        if (this.dataset.next) this.observer.observe(this);
      } catch (error) {
        this.observer?.disconnect();
      } finally {
        clearTimeout(timer);
        this.loading = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
